import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import HandlingExtra from 'components/form/Stop/HandlingExtra/HandlingExtra';
import prohibitedIcon from 'assets/icons/prohibited.svg';

export default styled(HandlingExtra)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  label {
    margin: 0 ${gridSizes('S')} 0 0;
  }
  .handling-text {
    display: inline-flex;
    gap: 5px;
    padding: 10px 0;
  }
  .handling-container {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    & svg path {
      fill: #94a6b8;
    }
  }
  .handling-btn-container {
    position: relative;
  }

  .handling-radio-btn {
    display: none;
  }

  .handling-radio-btn + label .input-representation {
    position: absolute;
    top: 5px;
    right: 15px;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    border: 1px solid #94a6b8;
    background-color: white;
  }
  .handling-radio-btn:checked + label .input-representation {
    border: 6px solid #0140cd;
  }
  .handling-radio-btn + label.disabled .input-representation {
    background-image: url(${prohibitedIcon});
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: 2px 2px;
  }

  .handling-radio-btn + label {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding-bottom: 5px;
    width: 136px;
    height: 83px;
    background-color: var(--white);
  }

  .handling-radio-btn + label:hover {
    background-color: var(--primary50);
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
  }
  .handling-radio-btn:checked + label {
    background-color: var(--primary200);
    box-shadow: inset 0px 2px 6px rgba(41, 41, 41, 0.25);
    & svg path {
      fill: #616161;
    }
  }
  .handling-container p {
    display: flex;
    align-items: center;
    color: #54708c;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    flex-basis: 250px;
    flex-grow: 1;
  }
  .handling-container p::before {
    content: '';
    display: block;
    border: 10px solid transparent;
    border-left: 10px solid #0140cd;
    max-height: 16px;
  }
  label.disabled:hover,
  label.disabled {
    cursor: no-drop;
    background: #e2e8ee;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
    color: #94a6b8;
    & svg path {
      fill: #94a6b8;
    }
  }
  .disabled-info-icon path {
    fill: #e37012 !important;
  }
  label.error:hover,
  label.error {
    border: solid 1px red;
  }

  .button-msg-error {
    background: #fff2e0;
    border: 1px solid #fcc475;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    border-radius: 4px;
    padding: 8px 16px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    height: 83px;
    & span {
      margin: 0;
    }
    & svg {
      width: 32px;
      margin-top: 0.3rem;
      fill: #e37012;
    }
  }
  .button-msg-error {
    display: inherit;
    opacity: 1;
    border: 0.5px solid red;
    background: #fedbdb;
    height: fit-content;
    align-self: flex-end;
    margin-bottom: 1rem;
    flex-basis: 150px;
    flex-grow: 1;
    & svg path {
      fill: red;
    }
  }
`;
